<template>
    <div class="block-bg-border block-bg-border-max-mob mt-6 p-5 max-mob:p-4">
        <div class="uppercase app-text-lg">
            Blocked Carriers
        </div>

        <div class="pt-2 app-text-xs">
            Block unwanted VoIP carriers
        </div>

        <CustomDivider class="my-4"/>

        <BlockedCarriersTable
            v-model:onPage="onPage"
            v-model:selected="selected"
            :headers="BLOCKED_CARRIERS_HEADERS"
            :items="carriers"
            :loading="loading"
            :showMultipleActions="showMultipleActions"
            @openBlockCarrierDialog="openBlockCarrierDialog"
            @openEditDialog="openEditDialog"
            @openDeleteDialog="openUnblockCarrierDialog"
            @openSelectDeleteDialog="openSelectUnblockCarrierDialog"
        />
    </div>

    <ConfirmDialog
        v-model="showConfirmDialog"
        :item="selectedItem"
        :loading="actionLoading"
        :title="titleDialog"
        :subTitle="subTitleDialog"
        :prop="propDialog"
        :confirmButtons="['Cancel', 'Confirm']"
        @submitForm="unblockCarrier"
    />

    <CreateEditBlockCarrier
        v-model="showCreateEditDialog"
        :selectedItem="selectedItem"
        :loading="actionLoading"
        :readonly="!editVoipShieldPermission"
        @editAction="editAction"
        @createAction="createAction"
    />
</template>

<script setup>
import { computed, ref } from 'vue'

import CustomDivider from '@/components/divider/CustomDivider.vue'
import BlockedCarriersTable from '@/views/call-tracking/voip-shield/components/tables/BlockedCarriersTable.vue'
import ConfirmDialog from '@/components/dialogs/ConfirmDialog.vue'
import CreateEditBlockCarrier from '@/views/call-tracking/voip-shield/components/dialogs/CreateEditBlockCarrier.vue'

import { useDetailVoipShieldStore } from '@/store/call-tracking/suppressionList/detailVoipShieldStore'
import { usePermissionsStore } from '@/store/permissionsStore'

import { BLOCKED_CARRIERS_HEADERS } from '@/constants/headersTable/blockedCarriersHeadersTable'

const detailVoipShieldStore = useDetailVoipShieldStore()
const permissionsStore = usePermissionsStore()

const showConfirmDialog = ref(false)
const showCreateEditDialog = ref(false)

const selectedItem = ref({})
const titleDialog = ref('')
const subTitleDialog = ref('')
const propDialog = ref('')

const editVoipShieldPermission = computed(() => permissionsStore.permissions.voipShield.edit)

const loading = computed(() => detailVoipShieldStore.loading)
const actionLoading = computed(() => detailVoipShieldStore.actionLoading)
const carriers = computed(() => detailVoipShieldStore.carriers)
const showMultipleActions = computed(() => !!detailVoipShieldStore.carriersSelected.length)

const onPage = computed({
    get() {
        return detailVoipShieldStore.onPage
    },
    set(newOnPage) {
        detailVoipShieldStore.changeOnPage(newOnPage)
    },
})

const selected = computed({
    get() {
        return detailVoipShieldStore.carriersSelected
    },
    set(newSelectedItems) {
        detailVoipShieldStore.changeSelectedItems(newSelectedItems)
    },
})

function openBlockCarrierDialog() {
    showCreateEditDialog.value = true

    selectedItem.value = {}
}

function openEditDialog(item) {
    showCreateEditDialog.value = true

    selectedItem.value = item
}

function openUnblockCarrierDialog(item) {
    showConfirmDialog.value = true

    selectedItem.value = item
    propDialog.value = 'name'
    titleDialog.value = 'UnBlock Carrier'
    subTitleDialog.value = 'Are you sure you want to unblock this Carrier?'
}

function openSelectUnblockCarrierDialog(item) {
    showConfirmDialog.value = true

    selectedItem.value = item
    propDialog.value = ''
    titleDialog.value = 'UNBLOCK SELECTED CARRIERS'
    subTitleDialog.value = 'Are you sure you want to unblock the selected Carriers?'
}

async function unblockCarrier(item) {
    const slugs = selected.value.length ? selected.value.map((item) => item.slug) : [item.slug]

    const { success } = await detailVoipShieldStore.goToUnblockCarrier(slugs)

    if (success) {
        showConfirmDialog.value = false
    }
}

async function createAction(item) {
    const { success } = await detailVoipShieldStore.goToAddCarrier(item)

    if (success) {
        showCreateEditDialog.value = false
    }
}

async function editAction(formData, slugCarrier) {
    const { success } = await detailVoipShieldStore.goToUpdateCarrier({ slugCarrier, formData })

    if (success) {
        showCreateEditDialog.value = false
    }
}
</script>
